module.exports = __webpack_public_path__ + "static/media/artificial-intellegence.74a6e024.svg";